export default __webpack_public_path__ + "static/media/pay-banner.18588cb5.png";